import { RISK_TONE, STATUS_TONE, READINESS_TONE } from "./constants";  // eslint-disable-line no-unused-vars

export function Pill({ tone, children, testId }) {
  return (
    <span className="hw-reg__pill"
          style={{ color: tone?.color, background: tone?.bg }}
          data-testid={testId}>
      {children}
    </span>
  );
}
